import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

export default function AllowRender({ roles, children }) {
	const [allow, setAllow] = useState(false);
	const role = useSelector((state) => state.auth?.user?.role);

	useEffect(() => {
		for (let i = 0; i < roles.length; i++) {
			const el = roles[i];

			if (role === el) {
				setAllow(true);
				break;
			}
		}
	}, [role, roles]);

	return <>{allow && children}</>;
}
